import { Text } from "@clipboard-health/ui-react";
import { Box } from "@mui/material";
import { PhoneField } from "@src/appV2/lib";
import { useFormContext } from "react-hook-form";

interface VerifyPhoneFormProps {
  onSubmit: (values: { phoneNumber: string }) => Promise<void>;
  id: string;
}

export function VerifyPhoneForm(props: VerifyPhoneFormProps) {
  const { onSubmit, id } = props;
  const { handleSubmit } = useFormContext<{ phoneNumber: string }>();

  return (
    <Box
      component="form"
      id={id}
      sx={{ display: "flex", flexDirection: "column", gap: 2, p: 2 }}
      onSubmit={handleSubmit(async (formData) => {
        await onSubmit(formData);
      })}
    >
      <Text sx={{ pb: 1 }}>Please enter your phone number to verify your account.</Text>
      <PhoneField name="phoneNumber" />
    </Box>
  );
}
